/** @prettier */
import React from 'react';

import ExternalLink from '@xanadu/ui-shared/components/widgets/ExternalLink';
import { TIME_TO_THINK } from '@xanadu/ui-shared/constants';

import styles from './TakeTimeToThinkBanner.module.scss';

const TakeTimeToThinkBanner = () => (
  <div className={styles.ttttContainer}>
    <div className={styles.tttt}>
      <ExternalLink href={TIME_TO_THINK} target="_blank" rel="noopener noreferrer">
        <img
          alt="take time to think"
          className={styles.ttttImage}
          src="/assets/images/footer/take-time-to-think_h-group.min.svg"
        />
      </ExternalLink>
    </div>
  </div>
);

export default TakeTimeToThinkBanner;
